export default __webpack_public_path__ + "static/media/elsewhere.5cda2e5a.svg";